import { get } from './helper';

export async function getDashboardInfo() {
  const res = await get({
    url: 'admin/dashboard',
  });
  return res?.data || res;
}

export async function getCalendarInfo({ year, month }) {
  const res = await get({
    url: 'admin/dashboard/calendar',
    data: { year, month },
  });
  return res?.data || res;
}

export async function getNews() {
  const res = await get({
    url: 'admin/dashboard/news',
  });

  return res?.data || res;
}

export default {
  getDashboardInfo,
  getCalendarInfo,
};
